import styled from 'styled-components';

export const DetailInfo = styled.section`
  display: flex;
  justify-content: space-between;
  padding: 0 50px;
  width: 100%;
  margin: 50px auto;

  @media all and (max-width: 960px) {
    flex-direction: column;
    padding: 0 20px;
  }
`;

export const ImageArea = styled.div`
  width: 100%;
  height: 500px;
  margin-left: 30px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  border-radius: 18px;

  div:nth-child(1) {
    height: 78vh;
  }

  @media (max-width: 960px) {
    width: 100%;
    margin-left: 0;

    div:nth-child(1) {
      height: auto;
    }
  }
`;
